<template>
  <div class="recs">
      <Recommendation v-for="(recommendation, i) in recommendations" :key="i" @delete="recommendations.splice(i,1)" :recommendation="recommendation" />
      <button @click="recommendations.push({reason:'',products:[],condition:[]})">
          Add Recommendation
      </button>
      <br>
      <br>
      <br>
      <textarea v-model="json" style="width:calc(100% - 64px);height:400px">
      </textarea>
      <br>
      <br>
      <br>
  </div>
</template>

<script>
import Recommendation from './Recommendation'
import recommendations from '@/assets/recommendations'

export default {
    name: 'RecommendationEditor',
    components: {
        Recommendation
    },
    data(){
        return {
        recommendations: recommendations
        }
    },
    computed: {
        json: {
            get(){
                return JSON.stringify(this.recommendations)
            },
            set(val){
                this.recommendations = JSON.parse(val)
            }
        }
    }
}
</script>

<style>
.recs{
    margin-bottom: 128px;
}
</style>